import { CompactPatientHeaderComponent } from '@/src/app/features/reports/components/compact-patient-header/compact-patient-header.component';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule.forChild(), CompactPatientHeaderComponent],
  exports: [CompactPatientHeaderComponent],
  providers: []
})
export class CompactPatientHeaderModule {}
